class ProductDetailsDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = document.querySelector('.product-details-drawer__overlay');
    this.closeButton = this.querySelector('.product-details-drawer__close');
    this.trigger = document.querySelector('.product-details-drawer__trigger');
    
    this.bindEvents();
  }

      bindEvents() {
      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.open());
      }
      
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
      
      if (this.overlay) {
        console.log('Overlay found and event bound');
        this.overlay.addEventListener('click', (e) => {
          console.log('Overlay clicked');
          // Only close if clicking directly on the overlay, not on its children
          if (e.target === this.overlay) {
            console.log('Closing drawer from overlay click');
            this.close();
          }
        });
      } else {
        console.log('Overlay not found');
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });
    }

  open() {
    console.log('Opening drawer');
    this.classList.add('is-open');
    document.body.classList.add('drawer-open');
    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
    console.log('Drawer opened, overlay should be visible');
  }

  close() {
    console.log('Closing drawer');
    this.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
    console.log('Drawer closed');
  }
}

customElements.define('product-details-drawer', ProductDetailsDrawer);
